// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"443b1f46","787":"a1128eb7"}[chunkId] + ".chunk.js";
};